import { render, staticRenderFns } from "./bsgLtcDetail.vue?vue&type=template&id=de56e2e8&scoped=true"
import script from "./bsgLtcDetail.vue?vue&type=script&lang=js"
export * from "./bsgLtcDetail.vue?vue&type=script&lang=js"
import style0 from "./bsgLtcDetail.vue?vue&type=style&index=0&id=de56e2e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de56e2e8",
  null
  
)

export default component.exports